const SV = "https://customer-assets-gfyr7b9c.emergentagent.net/job_sv-athletic-luxe/artifacts/";

export const IMG = {
  hero: SV + "alg2dojm_sv-charcoal-homepage-hero.png",
  heroDesktop: SV + "a837a1cj_exec-913b70c0-151e-4654-9414-4192a15c7b12.png",
  heroMobile: SV + "vj47e58o_exec-2ca407e8-408e-4ef3-a940-42bb3ff6c79b.png",
  silverIce: SV + "5hbivkey_exec-6cc9f733-0865-493c-81ad-3bcd46930735.png",
  wineCurvy: SV + "lmzb3y07_exec-8e87dc46-5d65-40ad-a749-6a0207b302ea.png",
  // SV campaign assets
  charcoalCrossback: SV + "dpwnufd6_sv-charcoal-crossback-set.png",
  charcoalMatcha: SV + "6a1ayiae_sv-charcoal-matcha-lifestyle.png",
  charcoalBack: SV + "7qraexay_sv-charcoal-back-view.png",
  blackLayering: SV + "5ib2oi9p_sv-black-layering-set.png",
  blackSelfie: SV + "0bdv1jv8_sv-black-selfie-lifestyle.png",
  blackDetail: SV + "wonrxj76_sv-black-detail.png",
  blackLifestyle: SV + "llwhn06o_sv-black-lifestyle.png",
  lavenderBack: SV + "r3biwjnu_sv-lavender-pocket-back-view.png",
  lavenderPuppy: SV + "olev8rd3_sv-lavender-puppy-lifestyle-v2.png",
  iceBlue: SV + "41q0bhli_sv-ice-blue-layering-set.png",
  iceFlower: SV + "e1mf4uah_sv-ice-blue-flower-market-lifestyle.png",
  wineSet: SV + "iw1dhyll_sv-wine-motion-set.png",
  wineDetail: SV + "rtjphlfv_sv-wine-motion-detail.png",
  wineCafe: SV + "iud6q0lh_sv-wine-cafe-lifestyle.png",
  community: SV + "7s7ed9pv_sv-community-campaign.png",
  // "Why SV" garment-detail image
  whySv: SV + "wonrxj76_sv-black-detail.png",
};

export const ACTIVITIES = [
  { label: "RUN", sub: "Find your pace.", img: SV + "3mwgumn5_exec-01be6857-a83a-4bcb-9eef-4f21b7584cc6.png", to: "/shop" },
  { label: "STRENGTH", sub: "Own your power.", img: SV + "2quwnfo4_exec-bc64a1ee-5d5a-4bae-8085-945b583a8ff9.png", to: "/shop" },
  { label: "PILATES", sub: "Move with control.", img: SV + "wegqt667_exec-ed29c7b7-71e2-41e8-befb-0b7634ecb3ec.png", to: "/shop" },
];

export const MOODS = [
  { color: "Deep Charcoal", mood: "Grounded", img: SV + "6a1ayiae_sv-charcoal-matcha-lifestyle.png", to: "/product/sv-form-cross-back-set" },
  { color: "Black", mood: "Unstoppable", img: SV + "0bdv1jv8_sv-black-selfie-lifestyle.png", to: "/product/sv-studio-three-piece-set" },
  { color: "Soft Lavender", mood: "Soft Strength", img: SV + "olev8rd3_sv-lavender-puppy-lifestyle-v2.png", to: "/product/sv-flow-pocket-set" },
  { color: "Ice Blue", mood: "Fresh Start", img: SV + "e1mf4uah_sv-ice-blue-flower-market-lifestyle.png", to: "/product/sv-ice-layering-set" },
  { color: "Wine Berry", mood: "Main Character", img: SV + "iud6q0lh_sv-wine-cafe-lifestyle.png", to: "/product/sv-motion-wrap-set" },
];

export const REAL_LIFE = {
  heading: "Designed For Real Life",
  copy: "From studio sessions to everyday movement, SV is designed to help women feel confident, comfortable, and ready for what comes next.",
};

// SV Off Duty — five uploaded lifestyle images (order per brief)
export const GALLERY = [
  SV + "6a1ayiae_sv-charcoal-matcha-lifestyle.png",
  SV + "0bdv1jv8_sv-black-selfie-lifestyle.png",
  SV + "olev8rd3_sv-lavender-puppy-lifestyle-v2.png",
  SV + "e1mf4uah_sv-ice-blue-flower-market-lifestyle.png",
  SV + "iud6q0lh_sv-wine-cafe-lifestyle.png",
];
